import type { NextPage } from 'next';
import { Page as Component } from '~/containers/specifics/vendors/settings/company_settings/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/settings/company_settings';

const CompanySetting: NextPage = () => (
  <>
    <NskHead title="管理会社一覧" />
    <Component />
  </>
);

export default CompanySetting;
